var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1202 32c3.333 0 6 2.667 6 6 0 1.152-.345 2.044-.94 2.947l-4.427 6.717c-.134.202-.367.336-.633.336s-.499-.133-.632-.335l-4.427-6.718c-.596-.903-.941-1.795-.941-2.947 0-3.333 2.667-6 6-6zm0 2.658c-1.841 0-3.333 1.494-3.333 3.337 0 1.842 1.492 3.337 3.333 3.337 1.841 0 3.333-1.495 3.333-3.337 0-1.843-1.492-3.337-3.333-3.337zm-.01 1.285c1.136 0 2.058.921 2.058 2.057s-.922 2.057-2.058 2.057c-1.136 0-2.057-.921-2.057-2.057s.921-2.057 2.057-2.057z",
    transform: "translate(-1196 -32)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.cf0044d4f4e80a46821d001543603377.svg";
export { ForwardRef as ReactComponent };